import { PsUserRole } from './PsUserRole';

export class PsUser {

    _id;
    _name;
    _lastName;
    _email;
    _role;
    _company; // Empresa a la que pertenece (Superadmin no pertenece a ninguna)
    _disabled;

    constructor(
        id,
        name,
        lastName,
        email,
        role,
        company,
        disabled,
    ) {
        this._id = id;
        this._name = name;
        this._lastName = lastName;
        this._email = email;
        this._role = role;
        this._company = company;
        this._disabled = disabled;
    }

    static fromBackend(user) {
        const rw = user.roles[0];
        const role = rw ? PsUserRole.fromBackend(rw.role) : PsUserRole.fromInvalid();
        const company = user.my_company ? user.my_company.name : '';

        return new this(
            user.id,
            user.name,
            user.last_name,
            user.email,
            role,
            company,
            user.disabled,
        );
    }

    static fromReduxState(state) {
        const currentUser = new this(state.auth.user);
        currentUser.setContractor(state.auth.contractor);
        return currentUser;
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    email() {
        return this._email;
    }

    role() {
        return this._role;
    }

    company() {
        return this._company;
    }

    isEnabled() {
        return !this._disabled;
    }

    isDisabled() {
        return this._disabled;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/model/PsUser.js